export const Work = [
    {
        id:1,
        name:"WallStreat",
        description:"An intuitive and feature-rich trading platform designed for modern traders. WallStreat provides real-time market data, powerful analytics, and an interactive user experience.",
        tags:["react","MySQL","Python"],
        
        demo:"https://wallstreat-beta.web.app/signup",
        github:"https://github.com/Edwardndiyo/WallStreat_Beta",

        // testing image inclusion 
        // image: "/images/lawbuddy.png"
    },
    {
        id:2,
        name:"EduMate",
        description:"A comprehensive desktop solution for managing students, featuring an intuitive admin dashboard, advanced financial tracking, and automation tools to streamline fee management and administrative tasks.",
        tags:["C#","WinForms", "SQLite"],
        
        demo:"/work",
        github:"https://github.com/Edwardndiyo/Aptech_Student_EnrollmentAPP_Project"
    },
    {
        id:3,
        name:"Wallstreat Token Bot",
        description:"A dynamic Telegram-based mining bot that allows users to mine tokens daily, earn rewards through referrals, and complete in-app tasks. Features an engaging user experience and real-time tracking.",
        tags:["react","api","Firebase"],
        
        demo:"https://t.me/WallStreat_TokenBot/start?=ref_767733703",
        github:"https://github.com/Edwardndiyo/Ai-token-bot"
    },
    {
        id:4,
        name:"Bank-Dash",
        description:"A robust and scalable backend system for a next-generation banking application, leveraging Python and MySQL for secure, efficient, and seamless financial transactions.",
        tags:["Python","MySql"],
        
        demo:"https://bank-dash-gilt.vercel.app/",
        github:"https://github.com/Edwardndiyo/AI-Token-Bot-Backend"
    },
    {
        id:5,
        name:"Tutor Nest",
        description:" TutorNest empowers tutors to create and manage virtual classrooms effortlessly. From organizing live classes and assigning quizzes to distributing assignments and tracking student progress, TutorNest provides a seamless digital learning experience.",
        tags:["react","Python"],
        
        // demo:"https://quiz-app-paradox.web.app/",
        demo: "/work",
        github:"https://github.com/Edwardndiyo/quiz-app"
    },
    {
        id:6,
        name:"Bellville Dental Clinic",
        description:"A sleek, responsive, and user-friendly website for Bellville Dental Clinic. Features include a visually appealing landing page, contact details, and an interactive appointment booking form.",
        tags:["Angular"],
        
        demo:"/work",
        github:"https://github.com/Edwardndiyo/BelleVille-Dental-E-Project.github.io"
    },
    {
        id:7,
        name:"Number Guessing Game",
        description:"A fun and interactive number guessing game with a competitive global leaderboard. Built for responsiveness, ensuring an enjoyable experience on all devices.",
        tags:["react","Python","MySql"],
        
        demo:"https://diced-ndiyo.web.app/login",
        github:"https://github.com/Edwardndiyo/Number_guessing_game-E-Project-"
    },
    {
        id:8,
        name:"EduMate Landing Page",
        description:"A visually appealing and responsive landing page designed to showcase the features of EduMate. Includes a download button and a contact form for potential users.",
        tags:["react","TailwindCSS","Shadcn"],
        
        demo:"https://edumate-paradox.vercel.app/",
        github:"https://github.com/Edwardndiyo/Edumate-landing-page"
    },
    {
        id:9,
        name:"Music Player Web App",
        description:"A smooth and intuitive web-based music player with a minimalist design, offering seamless audio playback and an engaging user experience.",
        tags:["HTML","Vanilla JS","css"],
        
        demo:"https://edwardndiyo.github.io/music-player.github.io/",
        github:"https://github.com/Edwardndiyo/music-player.github.io"
    },
    {
        id:10,
        name:"Ndiyo-Auth-X Node",
        description:"An open-source authentication SDK built for Node.js. Features advanced security mechanisms, including biometric authentication, optional blockchain integration, and Redis caching for performance optimization.",
        tags:["JavaScript"],
        
        demo:"https://www.npmjs.com/package/ndiyo-auth-x",
        github:"https://github.com/Edwardndiyo/AuthX_Node"
    },
    {
        id:11,
        name:"pyresponse-paradox",
        description:"PyResponse-Paradox is a lightweight Python library that standardizes API responses for Flask and FastAPI applications. It eliminates repetitive response handling, ensuring consistent formatting, structured error codes, and improved debugging across different endpoints.",
        tags:["python", "FastAPI", "Flask"],
        
        demo:"https://pypi.org/project/pyresponse-paradox/0.1.0/",
        github:"https://github.com/Edwardndiyo/PyResponse"
    },
    {
        id:12,
        name:"Tasty-eats",
        description:"TastyEats simplifies online food ordering by connecting customers with their favorite restaurants. Browse diverse menus, filter meals, and place orders seamlessly—all in one intuitive platform.",
        tags:["react","Python", "MySql"],
        
        demo:"https://paradox-tasty-eats.vercel.app/",
        github:"https://github.com/Edwardndiyo/tasty-eats"
    },
]
